module.exports = __webpack_public_path__ + "static/media/DSC_0461.13fb51ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0461.jpg
// module id = 668
// module chunks = 0